export * as Api from './api';
export var AdminUserRealm;
(function (AdminUserRealm) {
    AdminUserRealm["Super"] = "SUPER";
    AdminUserRealm["Eis"] = "EIS";
    AdminUserRealm["Lp"] = "LP";
})(AdminUserRealm || (AdminUserRealm = {}));
export var DirtyAuthCacheChangeType;
(function (DirtyAuthCacheChangeType) {
    DirtyAuthCacheChangeType["RoleChange"] = "role_change";
    DirtyAuthCacheChangeType["OrgRemoval"] = "org_removal";
})(DirtyAuthCacheChangeType || (DirtyAuthCacheChangeType = {}));
//# sourceMappingURL=index.js.map